import React, { useState, useEffect } from 'react';
import { Dropdown } from 'primereact/dropdown';
import { useGetProductGroupsQuery } from '../../api';

const ProductGroup = ({ value, onChange, className, disabled, placeholder = "Ürün Grubu seçiniz veya arayınız" }) => {
    const [selectedProduct, setSelectedProduct] = useState(null);
    const { data: productGroupResponse, isLoading } = useGetProductGroupsQuery();

    useEffect(() => {
        if (value) {
            setSelectedProduct(value);
        }
    }, [value]);

    // Handle selection change
    const handleSelectionChange = (e) => {
        setSelectedProduct(e.value);
        onChange(e.value);
    };

    return (
        <Dropdown
            value={selectedProduct}
            options={productGroupResponse?.data || []}
            onChange={handleSelectionChange}
            filter
            showClear
            className={className}
            placeholder={placeholder}
            loading={isLoading}
            disabled={disabled}
        />
    );
};

export default ProductGroup;
